import {createSlice, createSelector} from "@reduxjs/toolkit";
import {fetchTickerNews} from "../../api/tickersApi";
import {listNewsKeywords, fetchSiteNews} from "../../api/newsApi";

const newsSlice = createSlice({
  name: 'news',
  initialState: {
    view: 'tickers',
    keywords: null,
    tickerPageIndex: 0,
    sitePageIndex: 0,
    tickerListNews: [], // Stores array of news articles
    siteListNews: [], // Stores news articles from sites
    fetchedSymbols: [], // Tracks which symbols have been fetched
    hasFetchedKeywords: false, // New flag to track if keywords have been fetched
    hasMoreSiteNews: true, // Track if more site news is available
    siteNewsLoading: false,
    siteNewsError: null,
  },
  reducers: {
    toggleNewsView: (state, action) => {
      const newView = action.payload;
      state.view = newView;
    },
    incrementTickerPageIndex: (state) => {
      state.tickerPageIndex += 1;
    },
    resetSiteNews: (state) => {
      state.siteListNews = [];
      state.sitePageIndex = 0;
      state.hasMoreSiteNews = true;
      state.siteNewsError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTickerNews.fulfilled, (state, action) => {
        const { symbols, newsData } = action.payload;
        state.tickerListNews = [...state.tickerListNews, ...newsData];
        state.fetchedSymbols = [...state.fetchedSymbols, ...symbols];
        state.tickerPageIndex += 1;
      })
      .addCase(fetchTickerNews.rejected, (state, action) => {
        console.error('Error fetching ticker news:', action.payload);
      })
      .addCase(listNewsKeywords.fulfilled, (state, action) => {
        state.keywords = action.payload;
        state.hasFetchedKeywords = true;
      })
      .addCase(listNewsKeywords.rejected, (state, action) => {
        console.error('Error fetching news keywords:', action.payload);
      })
      .addCase(fetchSiteNews.pending, (state) => {
        state.siteNewsLoading = true;
        state.siteNewsError = null;
      })
      .addCase(fetchSiteNews.fulfilled, (state, action) => {
        const { articles, total_pages, page } = action.payload;
        state.siteListNews = [...state.siteListNews, ...articles];
        state.siteNewsLoading = false;
        state.hasMoreSiteNews = page < total_pages - 1;
        state.sitePageIndex = page;
      })
      .addCase(fetchSiteNews.rejected, (state, action) => {
        state.siteNewsLoading = false;
        state.siteNewsError = action.payload;
        console.error('Error fetching site news:', action.payload);
      });
  }
});

// Selectors
export const selectNewsView = state => state.news.view;
export const selectTickerNews = state => state.news.tickerListNews;
export const selectSiteNews = state => state.news.siteListNews;
export const selectSiteNewsLoading = state => state.news.siteNewsLoading;
export const selectSiteNewsError = state => state.news.siteNewsError;
export const selectHasMoreSiteNews = state => state.news.hasMoreSiteNews;
export const selectSitePageIndex = state => state.news.sitePageIndex;

export const { toggleNewsView, incrementTickerPageIndex, resetSiteNews } = newsSlice.actions;

export default newsSlice.reducer;